export const STORAGE_KEYS  = {
    localUser: "localUser",
    eleicao: "eleicao",
}